import { render, staticRenderFns } from "./intervieweedept.vue?vue&type=template&id=0d1a6af4&scoped=true&"
import script from "./intervieweedept.vue?vue&type=script&lang=js&"
export * from "./intervieweedept.vue?vue&type=script&lang=js&"
import style0 from "./intervieweedept.vue?vue&type=style&index=0&id=0d1a6af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1a6af4",
  null
  
)

export default component.exports